// Retourne toutes les semaines de l'année avec lundi comme premier jour
export const getWeeksMondaySunday = (year: number): Date[][] => {
  const weeks: Date[][] = [];

  // Premier jour de l'année
  const firstDay = new Date(year, 0, 1);
  // Aller au premier lundi de l'année
  const firstMonday = new Date(firstDay);
  while (firstMonday.getDay() !== 1) {
    firstMonday.setDate(firstMonday.getDate() + 1);
  }

  // Dernier jour de l'année
  const lastDay = new Date(year, 11, 31);
  // Aller au dernier dimanche de l'année
  const lastSunday = new Date(lastDay);
  while (lastSunday.getDay() !== 0) {
    lastSunday.setDate(lastSunday.getDate() + 1);
  }

  let currentMonday = new Date(firstMonday);

  while (currentMonday <= lastSunday) {
    const week: Date[] = [];
    for (let d = 0; d < 7; d++) {
      const day = new Date(currentMonday);
      day.setDate(currentMonday.getDate() + d);
      week.push(day);
    }
    weeks.push(week);
    currentMonday.setDate(currentMonday.getDate() + 7);
  }

  return weeks;
};
